import type { Reducer } from 'redux';

import { LOGOUT_SUCCESS } from 'features/auth/redux/types';
import { ADD_SUCCESS_MESSAGE, ADD_ERROR_MESSAGE, REMOVE_MESSAGE } from 'features/message/redux/types';
import { MessageActionsType } from 'features/message/redux/action';
import { Message } from 'features/message/ts/Message';
import { MessageType } from 'features/message/ts/MessageType';
import { Stack } from 'immutable';

export interface MessageState {
  messages: Stack<Message>;
}

export const INITIAL_STATE: MessageState = {
  messages: Stack(),
};

const messageReducer: Reducer<MessageState, MessageActionsType> = (state = INITIAL_STATE, action): MessageState => {
  switch (action.type) {
    case LOGOUT_SUCCESS:
      return INITIAL_STATE;
    case ADD_ERROR_MESSAGE:
      return {
        ...state,
        messages: state.messages.push({
          content: action.payload,
          type: MessageType.Error,
          timestamp: new Date().getTime(),
        }),
      };
    case ADD_SUCCESS_MESSAGE:
      return {
        ...state,
        messages: state.messages.push({
          content: action.payload,
          type: MessageType.Success,
          timestamp: new Date().getTime(),
        }),
      };
    case REMOVE_MESSAGE:
      return {
        ...state,
        messages: state.messages?.filter(message => message.timestamp !== action.payload),
      };
    default: {
      return state;
    }
  }
};

export default messageReducer;
